import { apiClient } from './apiClient';
import { Prompt, PromptCreate, PromptUpdate, PromptFilters } from '../types';

const BASE_URL = '/admin/prompts';
const TENANT_ACTIVE_URL = '/tenant/me/prompts/active';

export const promptService = {
  async list(filters?: PromptFilters): Promise<Prompt[]> {
    const params = new URLSearchParams();
    if (filters?.domain) params.append('domain', filters.domain);
    if (filters?.type) params.append('type', filters.type);
    if (filters?.include_deprecated) params.append('include_deprecated', 'true');

    const url = params.toString() ? `${BASE_URL}?${params}` : BASE_URL;
    const response = await apiClient.get<Prompt[]>(url);
    return response.data;
  },

  async get(id: string): Promise<Prompt> {
    const response = await apiClient.get<Prompt>(`${BASE_URL}/${id}`);
    return response.data;
  },

  async getActive(domain: string): Promise<Prompt> {
    const response = await apiClient.get<Prompt>(`${TENANT_ACTIVE_URL}/${domain}`);
    return response.data;
  },

  async create(data: PromptCreate): Promise<Prompt> {
    const response = await apiClient.post<Prompt>(BASE_URL, data);
    return response.data;
  },

  async update(id: string, data: PromptUpdate): Promise<Prompt> {
    const response = await apiClient.put<Prompt>(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  async activate(id: string): Promise<Prompt> {
    const response = await apiClient.post<Prompt>(`${BASE_URL}/${id}/activate`);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${BASE_URL}/${id}`);
  }
};
